/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, array, // number,
    string, func, bool, shape, number,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Error from '@material-ui/icons/Error';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import ReactMarkdown from 'react-markdown';
import { getProfileInfo, getIsAuthenticatedStatus } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import {
    getOrderId, getCartCount, getOrderContainsSubscriptionItem,
} from '../../../../state/ducks/Common/Common-Selectors';
import { getFeatureFlag, getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import WrapUpUI from './Partials/WrapUpUI';
import { getCart } from '../../../../state/ducks/Cart/Cart-Actions';
import { isProductAvailable, isProductPublished } from '../../Product/helpers/productHelpers';
import { setBrandMovieSkus } from '../../../../state/ducks/App/App-Actions';
import { triggerInterstitialLogin } from '../../../../state/ducks/Member/ducks/Auth/Auth-Actions';
import { clearAddToCartError, addUpsellsToCart } from '../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getAddToCartError, getAddToCartErrorList, getLastAddedOrderItemDetails } from '../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { skuBuilder } from '../../../pages/Checkout/containers/CheckoutFood/components/Partials/Helper/Helper';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getCartAttributeByNameAndReturnValue } from '../../../helpers/page/pageHelpers';
import AddonProductInfoUI from '../GraphqlAddOnsPage/Partials/AddonProductInfoUI';
import SliderAddon from '../GraphqlAddOnsPage/Partials/SliderAddon';
import ModalItemWrapper from '../GraphqlAddOnsPage/Partials/ModalItemWrapper';
import transformRenderer from '../../../helpers/markdown/characterTransformer';

const styles = (theme) => ({
    root: {
        margin: '0 auto',
        width: '100%',
        maxWidth: '1380px',
        paddingBottom: '20px',
    },
    addonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 auto',
        maxWidth: '1380px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            margin: '10px',
        },
    },
    addonInnerBlock: {
        padding: '0px 10px',
        '& > div': {
            display: 'flex',
            height: '100%',
        },
        [theme.breakpoints.down('md')]: {
            padding: 0,
            '& > div': {
                display: 'block !important',
                height: 'auto',
            },
        },
        '&:first-child': {
            paddingLeft: '0',
        },
        '&:last-child': {
            paddingRight: '0',
        },
    },
    buttonContinue: {
        margin: '40px auto 0 auto',
        width: '400px',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        backgroundColor: `${theme.palette.primaryButton || theme.palette.cms?.primary_hover}`,
        '&:hover': {
            backgroundColor: theme.palette.cms?.primary_hover,
        },
        borderRadius: '4px',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            width: '90%',
        },
        '@media screen and (min-width: 600px) and (max-width: 1024px)': {
            width: '50%',
        },
    },
    btnPill: {
        borderRadius: 24,
        height: 48,
        fontSize: 16,
        fontWeight: 'bold',
    },
    errorMsg: {
        color: theme.palette.error.main,
        padding: '1% 0%',
        width: '100%',
        wordWrap: 'break-word',
        display: 'inline-block',
        textAlign: 'center',
    },
    noItems: {
        textAlign: 'center',
    },
    wrapupHeader: {
        fontWeight: '600',
        fontSize: '16px',
        padding: '10px 10px 0 10px',
        margin: '0 0 10px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
    },
    wrapupHeading: {
        fontWeight: '600',
        fontSize: '14px',
        padding: '5px 10px 0 10px',
        margin: '15px 0 10px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#000000' || theme.palette.colorPrimary,
    },
    delivery: {
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        fontSize: '14px',
        padding: '0 0 15px 5px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#000000' || theme.palette.colorPrimary,
    },
    icon: {
        verticalAlign: 'bottom',
    },
    textCenter: {
        textAlign: 'center',
    },
    wrapper: {
        width: '100%',
        maxWidth: '766px',
        margin: '36px auto 70px',
        [theme?.breakpoints?.down('693')]: {
            margin: '16px auto 30px',
            width: '95%',
        },
    },
    titleSlider: {
        lineHeight: '36px',
        fontSize: '24px',
        display: 'flex',
        fontFamily: 'Playfair Display',
        margin: '0',
        padding: '0',
        '& span': {
            color: '#6E3290',
            marginLeft: '5px',
        },
        [theme?.breakpoints?.down(600)]: {
            lineHeight: '30px',
            fontSize: '20px',
            '& span': {
                color: '#6E3290',
                fontStyle: 'italic',
            },
        },
    },
    mainContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        marginTop: '60px',
        '@media screen and (max-width: 600px) ': {
            flexDirection: 'column-reverse',
            marginTop: '48x',
        },
    },
    buttonContinueWrapUp: {
        color: theme.palette.cms?.white || '#ffffff',
        width: '100%',
        cursor: 'pointer',
        padding: '15px 5px',
        fontSize: '18px',
        maxWidth: '50%',
        textAlign: 'center',
        lineHeight: '26px',
        borderRadius: '3px',
        fontFamily: 'LatoBold',
        backgroundColor: '#52A64A',
        textTransform: 'capitalize',
        marginLeft: '24px',
        '&:hover, &:focus, &:active': {
            backgroundColor: '#52A64A',
        },
        '@media screen and (max-width: 600px)': {
            maxWidth: '100%',
            marginLeft: '0px',
        },
    },
    btnShopping: {
        backgroundColor: theme.palette.cms?.white || '#ffffff',
        color: theme.palette.cms?.black || '#000000',
        marginLeft: '0px',
        border: '1px solid #000000',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.cms?.white || '#ffffff',
        },
        '@media screen and (max-width: 600px)': {
            marginTop: '20px',
        },
    },
    wrapWrapper: {
        marginTop: '40px',
        '@media screen and (max-width: 600px)': {
            marginTop: '32px',
        },
    },
    subTitleSlider: {
        lineHeight: '30px',
        fontSize: '18px',
        '& span': {
            color: '#6E3290',
            marginLeft: '5px',
            fontSize: '18px',
            fontStyle: 'italic',
            fontFamily: 'LatoBold',
        },
        [theme?.breakpoints?.down(600)]: {
            lineHeight: '30px',
            fontSize: '18px',
            '& span': {
                fontFamily: 'LatoBold',
                fontStyle: 'italic',
            },
        },
    },
    infoWrapper: {
        borderBottom: '1px solid #C4C4C4',
    },

    Wrapper: {
        '& $infoWrapper': {
            padding: '0px 0px 40px',
            [theme?.breakpoints?.down('600')]: {
                paddingBottom: '32px',
            },
            '& $buttonContainer': {
                marginTop: '0px',
                [theme?.breakpoints?.down('600')]: {
                    marginTop: '0px',
                },
            },
        },
    },
});

class WrapUpPageBuilder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItems: {},
            // New design support
            openModal: false,
            modalItemList: [],
            typeItem: '',
            groupItemId: '',
            groupItemName: '',
            showProgressBar: true,
        };
    }

    handleScroll = () => {
        if (typeof window !== 'undefined') {
            const header = document.querySelector('#global_header_container');
            const bodyHeight = document.querySelector('#wrapUpContainer');
            const totalHeight = bodyHeight?.offsetHeight + header?.offsetHeight - window.innerHeight;
            const containerHeight = totalHeight;
            this.setState({ showProgressBar: containerHeight >= window.scrollY });
        }
    }

    componentDidUpdate(previousProps) {
        const { lastAddedItem } = this.props;
        if (lastAddedItem?.product !== previousProps?.lastAddedItem?.product) {
            this.handleScroll();
        }
    }

    componentDidMount() {
        const {
            actionGetCart,
            callClearErrors,
            content,
            actionSetBrandMovieSkus,
            trackWrapUp,
            flags,
            callTrackData,
            wrapupAddonRedesign,
        } = this.props;
        trackWrapUp();
        callClearErrors();
        // retrives cart on mount so the relevent order details are saved in and accessible from redux
        actionGetCart();
        // eslint-disable-next-line consistent-return
        const movieSkus = content?.reduce((acc, skuWrapper) => {
            const skuData = skuWrapper.sku || {};
            const { name, id } = skuData;
            if (
                skuData?.parentProduct?.categories?.includes('digital_products')
                || name?.toLowerCase()?.includes('digital movie gift')
            ) {
                // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
                return { ...acc, [id.match(/[^-_]*$/)]: true };
            }
        }, {});
        if (typeof movieSkus === 'object') {
            actionSetBrandMovieSkus(movieSkus);
        }
        if (wrapupAddonRedesign) {
            callTrackData({
                eventCategory: 'Experiment',
                eventAction: 'Wrapup',
                eventLabel: 'Variant',
            });
        } else {
            callTrackData({
                eventCategory: 'Experiment',
                eventAction: 'Wrapup',
                eventLabel: 'Control',
            });
        }
        if (typeof document !== 'undefined') {
            document.addEventListener('scroll', this.handleScroll);
        }
    }

    componentWillUnmount() {
        // Remove scroll event when the component is unmounted
        if (typeof document !== 'undefined') {
            document.removeEventListener('scroll', this.handleScroll);
        }
    }

    handleContinue = () => {
        const { selectedItems } = this.state;
        const {
            actionAddUpsellsToCart,
            history,
            orderId,
            orderContainsSubscriptionItem,
            isAuthenticated,
            actionTriggerInterstitialLogin,
            lastAddedItem,
            ffIntersterstialEnabled,
            ffNativeIntersterstialEnabled,
            userProfile,
            cartCount,
            content,
            flags,
            atcLoginEnabled,
            callTrackData,
            wrapupAddonRedesign,
        } = this.props;
        let isRememberedUser = false;
        if (userProfile.email) {
            isRememberedUser = true;
        }
        const eventParam = {
            eventCategory: 'Experiment',
            eventAction: 'ATC Login Redirect',
            eventLabel: atcLoginEnabled ? 'Control' : 'Variant',
            feature_detail: atcLoginEnabled ? 'Control' : 'Variant',
            feature_element: 'ATC Login Redirect',
            feature_category: 'Experiment',
        };

        const categoryUrlOfLastAddedItem = getCartAttributeByNameAndReturnValue(lastAddedItem?.attributes || [], 'categoryPath');
        if (ffIntersterstialEnabled && (!isAuthenticated && !isRememberedUser) && orderContainsSubscriptionItem.length <= 0) {
            callTrackData(eventParam);
        }

        if (Object.keys(selectedItems).length > 0) {
            const wrapupList = Object.keys(selectedItems).map((item) => {
                const filteredWrapupItem = content?.find((wrapUpItem) => wrapUpItem?.sku?.id === selectedItems[item]?.id);
                const productCodeArray = selectedItems[item]?.skuInfo?.id.split('-');
                const productCode = productCodeArray?.[1] || '';
                const priceSelect = selectedItems[item]?.prices?.[1]?.value || selectedItems[item]?.prices?.[0]?.value || selectedItems[item]?.skuInfo?.prices?.[1]?.value || selectedItems[item]?.skuInfo?.prices?.[0]?.value;
                const wrapUpItem = {
                    lineItemType: 'WRAPUP',
                    addon: false,
                    baseCode: filteredWrapupItem?.sku?.parentProduct?.partNumber || selectedItems[item]?.skuInfo?.parentProduct?.partNumber,
                    brandCode: selectedItems[item]?.brandId || selectedItems[item]?.skuInfo?.brandId,
                    price: priceSelect,
                    productCode: wrapupAddonRedesign ? productCode : item,
                    productId: '',
                    quantity: '1',
                    name: selectedItems[item]?.name || selectedItems[item]?.skuInfo?.name,
                    partNumber: wrapupAddonRedesign ? selectedItems[item]?.skuInfo?.id : selectedItems[item]?.id,
                };
                if (typeof categoryUrlOfLastAddedItem === 'string') {
                    wrapUpItem.attributes = [
                        {
                            attributeName: 'categoryPath',
                            attributeValue: categoryUrlOfLastAddedItem,
                        },
                    ];
                }

                // The products only needs firstname, lastname and email,
                // without send emails at the end of place order (example: market place vendor)
                if (
                    selectedItems[item]?.parentProduct?.categories?.includes('digital_delivery')
                ) {
                    wrapUpItem.lineItemType = 'DDELVR';
                }

                if (
                    selectedItems[item]?.parentProduct?.categories?.includes('digital_delivery')
                ) {
                    // if the wrapup item is a movie item then add below lineItemType to
                    // correctly calculate tax
                    wrapUpItem.lineItemType = 'DDELVR';
                }

                if (
                    selectedItems[item]?.parentProduct?.categories?.includes('digital_products')
                    || selectedItems[item]?.name?.toLowerCase()?.includes('digital movie gift')
                ) {
                    // if the wrapup item is a movie item then add below lineItemType to
                    // correctly calculate tax
                    wrapUpItem.lineItemType = 'NBCU';
                }
                return wrapUpItem;
            });

            const payload = {
                cartItemId: lastAddedItem?.cartItemId || '',
                products: wrapupList,
            };

            actionAddUpsellsToCart(payload, history);
        } else if (orderContainsSubscriptionItem.length > 0 && !isAuthenticated) {
            actionTriggerInterstitialLogin(history, true);
        } else if (((ffIntersterstialEnabled && atcLoginEnabled) || ffNativeIntersterstialEnabled) && !isAuthenticated && !isRememberedUser) {
            actionTriggerInterstitialLogin(history);
        } else if (cartCount > 1) { // redirect added to handle case where there is one item in the cart
            history.push(`/checkout/cart/${orderId}`);
        } else {
            history.push(`/checkout/shipping/${orderId}`);
        }
    }

    selectedItem = (itemId, itemInfo) => {
        const { callClearErrors, wrapUpData, callTrackData } = this.props;
        const { selectedItems } = this.state;
        const newSelectedItems = Object.assign(selectedItems);
        const wrapUps = wrapUpData?.findContent?.content?.entries?.[0]?.wrap_up || [];
        const currentItem = wrapUps.find((item) => item?.sku === itemInfo?.id);
        if (selectedItems[itemId]) {
            // If the wrap item is in the object delete it as it is no longer selected.
            delete newSelectedItems[itemId];
            callTrackData({
                eventCategory: currentItem?.ga_tracking?.tracking_event_category || '',
                eventAction: `Removed - ${currentItem?.ga_tracking?.tracking_event_action}`,
                eventLabel: currentItem?.ga_tracking?.tracking_event_label,
            });
        } else {
            // If the wrap is not already in the object add it
            newSelectedItems[itemId] = itemInfo;
            callTrackData({
                eventCategory: currentItem?.ga_tracking?.tracking_event_category || '',
                eventAction: `Selected - ${currentItem?.ga_tracking?.tracking_event_action}`,
                eventLabel: currentItem?.ga_tracking?.tracking_event_label,
            });
        }
        this.setState({
            selectedItems: newSelectedItems,
        });
        callClearErrors();
    }

    isSelectedItemChecked = (wrapUpData) => {
        const { skuPartNumber } = wrapUpData;
        const itemId = skuBuilder(skuPartNumber);
        const { selectedItems } = this.state;
        return Object.keys(selectedItems).includes(itemId);
    }

    handleCloseModal = () => {
        this.setState({
            openModal: false,
            modalItemList: {},
            typeItem: '',
            groupItemId: '',
        });
    }

    selectWrapupItems = (skuInfo) => {
        const { selectedItems } = this.state;
        const { callTrackData, wrapUpData } = this.props;
        const newSelectedWrapupItems = Object.assign(selectedItems);
        const wrapUps = wrapUpData?.findContent?.content?.entries?.[0]?.wrap_up || [];
        const parentPartNumber = skuInfo?.parentProduct?.partNumber.split('-P-')[1];
        const currentItem = wrapUps.find((item) => item?.sku.includes(parentPartNumber));
        if (newSelectedWrapupItems?.[skuInfo?.id]) {
            callTrackData({
                eventCategory: currentItem?.ga_tracking?.tracking_event_category || '',
                eventAction: `Removed - ${currentItem?.ga_tracking?.tracking_event_action}`,
                eventLabel: currentItem?.ga_tracking?.tracking_event_label || '',
            });
            delete newSelectedWrapupItems[skuInfo.id];
        } else {
            callTrackData({
                eventCategory: currentItem?.ga_tracking?.tracking_event_category || '',
                eventAction: `Selected - ${currentItem?.ga_tracking?.tracking_event_action}`,
                eventLabel: currentItem?.ga_tracking?.tracking_event_label || '',
            });
            newSelectedWrapupItems[skuInfo.id] = {
                skuInfo,
            };
        }
        this.setState({
            selectedItems: newSelectedWrapupItems,
        });
    };

    removeSelectedItem(itemId) {
        const { selectedItems } = this.state;
        if (selectedItems[itemId]) {
            const newSelectedItems = Object.assign(selectedItems);
            delete newSelectedItems[itemId];
            this.setState({
                selectedItems: newSelectedItems,
            });
        }
    }

    getErrorMessage = () => {
        const { addToCartError, addToCartErrorList } = this.props;
        const { selectedItems } = this.state;
        let message = addToCartError;
        if (addToCartErrorList?.length > 0) {
            // If the error is an object is because the issue is an specific products
            message = addToCartErrorList.map((itemError) => {
                const keySku = skuBuilder(itemError.errorKey);
                this.removeSelectedItem(keySku);
                if (selectedItems?.[keySku]?.name) {
                    return `"${selectedItems[keySku].name.trim()}" ${itemError.errorMessage}`;
                }
                return itemError.errorMessage;
            });
            message = message.join('/ ');
        } else if (message && message.includes(':') && !addToCartErrorList?.length) {
            const singleSKU = message.split(':')[0];
            this.removeSelectedItem(singleSKU);
        }

        return message;
    }

    handleOpenModal = (type, itemList, groupItemId, groupItemName, typeBtn) => {
        const { callTrackData, flags, wrapupAddonRedesign } = this.props;
        if (wrapupAddonRedesign) {
            callTrackData({
                eventCategory: 'Experiment',
                eventAction: type,
                eventLabel: `${typeBtn} ${groupItemId}`,
            });
        }
        this.setState({
            openModal: true,
            modalItemList: itemList,
            typeItem: type,
            groupItemId,
            groupItemName,
        });
    }

    getSelectWrapupByGroup = (wrapupData) => {
        const { selectedItems } = this.state;
        const selectedWrapups = []; // array of strings of skus
        let selectedWrapupItemId = '';
        Object.keys(selectedItems).forEach((sku) => {
            selectedWrapups.push(sku);
        });
        // passing the item seleted item id
        if (Object.keys(selectedItems).length > 0) { // state object for selected is not 0
            const selected = selectedWrapups.filter((item) => item === wrapupData?.sku?.id);
            if (selected !== null) {
                selectedWrapupItemId = selected[0];
            }
            if (!selectedWrapupItemId) {
                selectedWrapupItemId = '';
            }
        }
        return selectedWrapupItemId;
    }

    renderWrapUpButton = () => {
        const {
            classes, history,
        } = this.props;
        return (
            <div className={`${classes.buttonContainer} `}>
                <Button
                    color="primary"
                    data-test="btn-continue-shopping"
                    className={`${classes.buttonContinueWrapUp} ${classes.btnShopping}`}
                    onKeyDown={() => { }}
                    onClick={() => {
                        history.goBack();
                    }}
                >
                    Continue Shopping
                </Button>
                <Button
                    id="btnCheckout"
                    data-test="btn-add-to-cart"
                    data-testid="btn-add-to-cart"
                    className={classes.buttonContinueWrapUp}
                    tabIndex={-1}
                    onClick={() => this.handleContinue()}
                >
                    Checkout
                </Button>
            </div>
        );
    }

    render() {
        const {
            classes, content, addToCartError, hasDetails, wrapUpData, presentationFamily, ctaPositionVariant,
            history, ssrDeviceType, lastAddedItem, wrapupAddonRedesign, flags, callTrackData, whichSubText,
        } = this.props;
        const {
            selectedItems, typeItem, modalItemList, groupItemId, groupItemName, openModal, showProgressBar,
        } = this.state;
        const {
            heading = null, sub_heading = '', heading_font_style = {}, wrap_up = [],
        } = wrapUpData?.findContent?.content?.entries?.[0] || {};

        const isFood = presentationFamily === 'food';
        const isMobile = ssrDeviceType.toLowerCase() === 'mobile';

        // regex remove text "font-family:" from string
        const setFontFamily = (fontData) => {
            let getFont = '';
            if (fontData) {
                getFont = fontData?.replace(/font-family: |;/g, '');
            }
            return getFont;
        };

        // use for heading style from CMS
        let headerFontStyle = {};
        headerFontStyle = {
            fontSize: heading_font_style?.font_size,
            fontWeight: heading_font_style?.font_weight,
            color: '#000000',
            fontFamily: setFontFamily(heading_font_style?.font_family),
            textAlign: heading_font_style?.text_alignment,
            textTransform: heading_font_style?.text_transform,
        };

        return (
            <div className={`${wrapupAddonRedesign ? classes.mainContainer : ''} ${ctaPositionVariant && wrapupAddonRedesign ? classes.Wrapper : ''}`}>
                <div className={`${classes.root} ${wrapupAddonRedesign ? classes.wrapper : ''}`}>
                    {wrapupAddonRedesign
                        ? (
                            <div id="wrapUpContainer">
                                {lastAddedItem?.product ? (
                                    <div className={classes.infoWrapper}>
                                        <AddonProductInfoUI
                                            productDetails={lastAddedItem}
                                            wrapupAddonRedesign={wrapupAddonRedesign}
                                        />
                                        {ctaPositionVariant && this.renderWrapUpButton()}
                                    </div>
                                ) : null}
                                <div className={classes.wrapWrapper}>
                                    {heading ? <div className={classes.titleSlider}><ReactMarkdown renderers={transformRenderer} source={heading} escapeHtml={false} /></div> : <div className={classes.titleSlider}><strong> Customer Favorites - Shipped Separately</strong></div>}
                                    {sub_heading ? <div className={classes.subTitleSlider}><ReactMarkdown renderers={transformRenderer} source={sub_heading} escapeHtml={false} /></div>
                                        : (
                                            <> {whichSubText?.preText ? (
                                                <div className={classes.subTitleSlider}>{whichSubText?.preText}<span>{whichSubText?.postText}</span></div>) : <></>}
                                            </>
                                        )}
                                    <SliderAddon
                                        handleOpenModal={this.handleOpenModal}
                                        selectedItems={selectedItems}
                                        addOnHoverInfo={wrap_up}
                                        content={content}
                                        getSelectAddonsByGroup={this.getSelectWrapupByGroup}
                                        addOnData={wrapUpData}
                                        isWrap
                                        selectItems={this.selectWrapupItems}
                                        wrapupAddonRedesign={wrapupAddonRedesign}
                                    />
                                </div>
                                {(!ctaPositionVariant || !lastAddedItem?.product) && this.renderWrapUpButton()}
                            </div>
                        )
                        : (
                            <>
                                <Grid>
                                    {heading
                                        ? <div className={classes.wrapupHeader}><ReactMarkdown renderers={transformRenderer} source={heading} escapeHtml={false} /></div>
                                        : <h2 className={classes.wrapupHeader}>Add to your gift and we&apos;ll ship it for no additional charge</h2>}
                                    {sub_heading ? <div className={classes.delivery}><ReactMarkdown renderers={transformRenderer} source={sub_heading} escapeHtml={false} /></div> : <h2 className={classes.delivery} style={headerFontStyle}>Choose a delivery date on payment & review</h2>}
                                </Grid>
                                <div className={classes.addonWrapper}>
                                    {content.map((addonItem) => (
                                        isProductAvailable(addonItem.sku) && isProductPublished(addonItem.sku) ? <div className={classes.addonInnerBlock}><WrapUpUI key={addonItem?.sku?.id} wrapupData={addonItem} selectedItem={this.selectedItem} isSelectedItemChecked={this.isSelectedItemChecked(addonItem)} movieWrapupData={wrapUpData} /> </div> : null
                                    ))}
                                </div>
                            </>
                        )}
                    <div>
                        {addToCartError
                            && (
                                <Typography
                                    align="center"
                                    variant="body2"
                                    className={classes.errorMsg}
                                >
                                    <Error className={classes.icon} color="error" />
                                    <span> {ReactHtmlParser(this.getErrorMessage())} </span>
                                </Typography>
                            )}
                    </div>
                    <div>
                        {!hasDetails && (<p className={classes.noItems}>No Wrapup products available, To proceed please click continue</p>)}
                    </div>
                    {wrapupAddonRedesign ? '' : (
                        <div className={classes.textCenter}>
                            <Button
                                color="primary"
                                id="btnAddToCart"
                                data-test="btn-add-to-cart"
                                className={`${classes.buttonContinue} ${isFood ? classes.btnPill : ''}`}
                                onKeyDown={() => { }}
                                tabIndex={-1}
                                role="button"
                                onClick={() => {
                                    this.handleContinue();
                                    callTrackData({
                                        eventName: 'feature_interaction',
                                        eventCategory: 'Wrap Up Products',
                                        eventAction: 'Checkout button clicked',
                                    });
                                }}
                            >
                                {isFood ? 'Checkout' : 'Continue'}
                            </Button>
                            {isMobile && isFood && (
                                <Button
                                    color="primary"
                                    data-test="btn-continue-shopping"
                                    className={`${classes.buttonContinue} ${classes.btnShopping}`}
                                    onKeyDown={() => { }}
                                    onClick={() => {
                                        history.goBack();
                                        callTrackData({
                                            eventName: 'feature_interaction',
                                            eventCategory: 'Wrap Up Products',
                                            eventAction: 'Continue button clicked',
                                        });
                                    }}
                                >
                                    Continue Shopping
                                </Button>
                            )}
                        </div>
                    )}
                    {openModal && wrapupAddonRedesign && typeItem === 'wrapup' && modalItemList.sku
                        ? (
                            <ModalItemWrapper
                                selectItems={this.selectWrapupItems}
                                typeItem={typeItem}
                                modalItemList={modalItemList}
                                isOpen={openModal}
                                btnClose
                                onCloseModal={this.handleCloseModal}
                                groupItemId={groupItemId}
                                groupItemName={groupItemName}
                                selectedItems={selectedItems?.[groupItemId]?.skuInfo}
                                wrapupAddonRedesign={wrapupAddonRedesign}
                            />
                        ) : null}
                </div>
            </div>
        );
    }
}

WrapUpPageBuilder.propTypes = {
    classes: object.isRequired,
    content: array.isRequired,
    wrapUpData: shape({
        heading: string,
    }),
    history: object.isRequired,
    actionAddUpsellsToCart: func.isRequired,
    callClearErrors: func.isRequired,
    actionGetCart: func.isRequired,
    hasDetails: bool.isRequired,
    orderId: string.isRequired,
    actionSetBrandMovieSkus: func.isRequired,
    orderContainsSubscriptionItem: array,
    isAuthenticated: bool,
    actionTriggerInterstitialLogin: func.isRequired,
    lastAddedItem: object,
    addToCartError: string,
    addToCartErrorList: array,
    presentationFamily: string,
    ssrDeviceType: string,
    ffIntersterstialEnabled: bool,
    ffNativeIntersterstialEnabled: bool,
    userProfile: shape({
        email: string,
    }),
    cartCount: number.isRequired,
    callTrackData: func,
    trackWrapUp: func.isRequired,
    flags: object,
    atcLoginEnabled: bool,
    wrapupAddonRedesign: bool,
    whichSubText: object,
    ctaPositionVariant: bool,
};

WrapUpPageBuilder.defaultProps = {
    orderContainsSubscriptionItem: [],
    isAuthenticated: false,
    wrapUpData: {},
    lastAddedItem: {},
    addToCartError: '',
    addToCartErrorList: [],
    presentationFamily: '',
    ssrDeviceType: '',
    ffIntersterstialEnabled: false,
    ffNativeIntersterstialEnabled: false,
    userProfile: {
        email: '',
    },
    flags: {},
    atcLoginEnabled: false,
    wrapupAddonRedesign: false,
    callTrackData: () => { },
    whichSubText: {},
    ctaPositionVariant: false,
};

const mapStateToProps = (state) => ({
    cartCount: getCartCount(state),
    orderId: getOrderId(state),
    addToCartError: getAddToCartError(state),
    addToCartErrorList: getAddToCartErrorList(state),
    ffIntersterstialEnabled: getFeatureFlag('is-interstitial-login-enabled')(state),
    ffNativeIntersterstialEnabled: getFeatureFlag('is-native-interstitial-page-enabled')(state),
    whichSubText: getFeatureFlag('which-wrapup-sub-heading')(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    userProfile: getProfileInfo(state),
    orderContainsSubscriptionItem: getOrderContainsSubscriptionItem(state),
    lastAddedItem: getLastAddedOrderItemDetails(state),
    presentationFamily: getPresentationFamily(state),
    ssrDeviceType: getSSRDeviceType(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionAddUpsellsToCart: bindActionCreators(addUpsellsToCart, dispatch),
    callClearErrors: bindActionCreators(clearAddToCartError, dispatch),
    actionGetCart: bindActionCreators(getCart, dispatch),
    actionSetBrandMovieSkus: bindActionCreators(setBrandMovieSkus, dispatch),
    actionTriggerInterstitialLogin: bindActionCreators(triggerInterstitialLogin, dispatch),
    callTrackData: bindActionCreators(trackEvent, dispatch),
});

const enhance = compose(
    withLDConsumer(),
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    withRouter,
);
export default enhance(WrapUpPageBuilder);
